//import React from 'react';
import React, { useEffect, useState } from "react";
import './Adaptation.css';



const translations = {
  english: {
    energyTitle: "How can SMEs in the energy sector address climate risks?",
    energyExamples: [
      {
        title: "Example 1: Heatwaves and Heat-Stress on Solar Power Systems",
        impactTitle: "Impact:",
        impactText: "Prolonged heatwaves can lead to overheating of solar panels, reducing their efficiency and lifespan. High temperatures may also increase the risk of fires in areas surrounding the installation.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Cooling Systems: Implement active cooling systems for solar panels to maintain optimal operating temperatures.",
          measure2: "Material Selection: Use heat-resistant materials for solar panels and mounts to reduce the impact of extreme heat.",
          measure3: "Vegetation Management: Regularly clear vegetation around the installation to reduce fire risk and improve air circulation.",
          measure4: "Monitoring Systems: Install temperature sensors and monitoring systems to track heat-related stress and take timely actions."
        }
      },
      {
        title: "Example 2: Changing Wind Patterns and Storms Affecting Wind Turbines",
        impactTitle: "Impact:",
        impactText: "Stronger and more frequent storms could increase wear and tear on wind turbines, leading to mechanical failures. Changing wind patterns may also affect energy production levels.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Structural Reinforcements: Strengthen turbine towers and blades to withstand stronger winds and storm conditions.",
          measure2: "Wind Monitoring: Use advanced meteorological monitoring systems to predict wind patterns and adjust turbine operations accordingly.",
          measure3: "Maintenance Schedules: Increase the frequency of maintenance checks, especially after storms, to identify and repair any damage early.",
          measure4: "Insurance: Ensure comprehensive insurance coverage for storm damage to minimize financial risk."
        }
      },
      {
        title: "Example 3: Heavy Precipitation Impacting Hydroelectric Power Stations",
        impactTitle: "Impact:",
        impactText: "Heavy rainfall and flooding can damage infrastructure, lead to sediment buildup, and cause operational disruptions at hydroelectric power stations.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Flood Barriers: Install flood barriers around key infrastructure to protect against rising water levels.",
          measure2: "Sediment Management: Implement sediment management systems, such as silt traps, to prevent blockages in turbines and other equipment.",
          measure3: "Infrastructure Design: Design spillways and overflow channels to handle increased water volumes without damaging the facility.",
          measure4: "Emergency Response Plans: Develop and regularly update emergency response plans for extreme weather events to ensure quick and effective action during heavy rainfall."
        }
      }
    ],
    manufacturingTitle: "How can SMEs in the manufacturing sector address climate risks?",
    manufacturingExamples: [
      {
        title: "Example 1: Supply Chain Disruptions Due to Extreme Weather Events",
        impactTitle: "Impact:",
        impactText: "Extreme weather events can disrupt the supply chain for key materials, affecting the timely production of renewable energy technologies.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Diversified Supply Chains: Source materials from multiple suppliers across different regions to reduce dependency on one area prone to climate risks.",
          measure2: "Inventory Management: Increase the stock of critical materials to buffer against supply chain interruptions.",
          measure3: "Advanced Weather Monitoring: Utilize weather prediction technologies to anticipate and mitigate potential disruptions."
        }
      },
      {
        title: "Example 2: Flooding Risks in Manufacturing Facilities",
        impactTitle: "Impact:",
        impactText: "Flooding due to heavy precipitation can damage production lines and disrupt the manufacturing of renewable energy components.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Flood-Resilient Infrastructure: Elevate manufacturing equipment and install flood barriers around facilities that might be prone to flooding.",
          measure2: "Waterproofing Systems: Use waterproof materials and sealants to protect machinery and infrastructure from potential water damage."
        }
      }
    ],
    constructionTitle: "How can SMEs in the construction sector address climate risks?",
    constructionExamples: [
      {
        title: "Example 1: Heatwaves and Worker Safety on Construction Sites",
        impactTitle: "Impact:",
        impactText: "Extreme heat during construction can lead to heat stress for workers, reduce productivity, and increase the risk of accidents.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Work Schedule Adjustments: Shift construction hours to early mornings or late afternoons to avoid peak heat periods.",
          measure2: "Cooling Stations: Set up shaded rest areas and cooling stations with water and fans to allow workers to cool down during breaks.",
          measure3: "Heat-Resistant Equipment: Use construction equipment that can operate efficiently in high temperatures to prevent overheating or breakdowns."
        }
      },
      {
        title: "Example 2: Increased Rainfall and Flooding Delaying Construction Timelines",
        impactTitle: "Impact:",
        impactText: "Heavy rainfall during construction can flood sites, damage materials, and delay project timelines.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Temporary Drainage Systems: Install temporary drainage solutions like trenches or pumps to redirect excess water away from the construction site.",
          measure2: "Waterproof Storage for Materials: Store materials in waterproof containers or elevated storage areas to protect them from rain damage.",
          measure3: "Weather-Resilient Site Planning: Adjust site grading and layout to minimize water pooling and flooding during rainstorms."
        }
      },
      {
        title: "Example 3: Storms and High Winds Affecting Construction Equipment and Structures",
        impactTitle: "Impact:",
        impactText: "Strong winds during construction can damage scaffolding, cranes, and incomplete structures, posing safety risks to workers and halting progress.",
        adaptationMeasuresTitle: "Adaptation Measures:",
        adaptationMeasures: {
          measure1: "Wind-Resistant Scaffolding: Use heavy-duty scaffolding and secure cranes with wind-resistant fastenings to prevent equipment from toppling during storms.",
          measure2: "Pre-Storm Site Securing: Develop procedures to quickly secure or dismantle temporary structures and equipment when high winds are forecasted.",
          measure3: "Real-Time Weather Monitoring: Implement real-time weather monitoring systems to provide advance warnings for workers, allowing them to secure equipment and evacuate if necessary."
        }
      }
    ]
  },
  german: {
    energyTitle: "Wie können KMU im Energiesektor Klimarisiken begegnen?",
    energyExamples: [
      {
        title: "Beispiel 1: Hitzewellen und Hitzestress für Solaranlagen",
        impactTitle: "Auswirkungen:",
        impactText: "Anhaltende Hitzewellen können zur Überhitzung von Solarmodulen führen, was deren Effizienz und Lebensdauer verringert. Hohe Temperaturen können auch die Brandgefahr in der Umgebung der Anlage erhöhen.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Kühlsysteme: Einsatz aktiver Kühlsysteme für Solarmodule zur Aufrechterhaltung optimaler Betriebstemperaturen.",
          measure2: "Materialauswahl: Hitzebeständige Materialien für Solarmodule und Befestigungen verwenden, um die Auswirkungen extremer Hitze zu reduzieren.",
          measure3: "Vegetationsmanagement: Regelmäßiges Entfernen der Vegetation um die Anlage herum, um die Brandgefahr zu verringern und die Luftzirkulation zu verbessern.",
          measure4: "Überwachungssysteme: Installation von Temperatursensoren und Überwachungssystemen, um hitzebedingte Belastungen zu erkennen und rechtzeitig Maßnahmen ergreifen zu können."
        }
      },
      {
        title: "Beispiel 2: Änderungen der Windverhältnisse und Stürme mit Auswirkungen auf Windkraftanlagen",
        impactTitle: "Auswirkungen:",
        impactText: "Stärkere und häufigere Stürme könnten den Verschleiß von Windkraftanlagen erhöhen und zu mechanischen Ausfällen führen. Zudem können sich veränderte Windverhältnisse auf die Energieerzeugung auswirken.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Strukturelle Verstärkungen: Verstärkung von Turbinentürmen und Rotorblättern, um stärkeren Winden und Stürmen standzuhalten.",
          measure2: "Windüberwachung: Einsatz moderner meteorologischer Überwachungssysteme zur Vorhersage von Windverhältnissen und entsprechende Anpassung des Turbinenbetriebs.",
          measure3: "Wartungspläne: Erhöhen der Häufigkeit von Wartungsinspektionen, insbesondere nach Stürmen, um mögliche Schäden frühzeitig zu erkennen und zu beheben.",
          measure4: "Versicherung: Sicherstellen eines umfassenden Versicherungsschutzes gegen Sturmschäden, um das finanzielle Risiko zu minimieren."
        }
      },
      {
        title: "Beispiel 3: Starke Niederschläge mit Auswirkungen auf Wasserkraftwerke",
        impactTitle: "Auswirkungen:",
        impactText: "Starkniederschläge und Überschwemmungen können Infrastruktur beschädigen, zu Sedimentablagerungen führen und den Betrieb von Wasserkraftwerken stören.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Hochwasserbarrieren: Errichtung von Hochwasserschutzbarrieren rund um wichtige Infrastrukturanlagen zum Schutz vor steigenden Wasserständen.",
          measure2: "Sedimentmanagement: Einführung von Sedimentmanagementsystemen wie z.B. Schlammfänge, um Verstopfungen von Turbinen und anderen Anlagen zu verhindern.",
          measure3: "Planung der Infrastruktur: Hochwasserentlastungsanlagen und Überlaufkanäle so planen, dass größere Wassermengen aufgenommen werden können, ohne die Anlagen zu beschädigen.",
          measure4: "Notfallpläne: Entwicklung und regelmäßige Aktualisierung von Notfallplänen für extreme Wetterereignisse, um bei Starkregenereignissen schnell und effektiv reagieren zu können."
        }
      }
    ],
    manufacturingTitle: "Wie können KMU im verarbeitenden Gewerbe Klimarisiken begegnen?",
    manufacturingExamples: [
      {
        title: "Beispiel 1: Unterbrechung der Lieferkette durch Extremwetterereignisse",
        impactTitle: "Auswirkungen:",
        impactText: "Extreme Wetterereignisse können die Lieferkette für wichtige Materialien unterbrechen und damit die zeitgerechte Produktion von Technologien für erneuerbare Energien beeinträchtigen. ",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Diversifizierung der Lieferketten: Beschaffung von Materialien von mehreren Lieferanten in verschiedenen Regionen, um die Abhängigkeit von einer Region, die anfällig für Klimarisiken ist, zu verringern.",
          measure2: "Lagerhaltung: Erhöhung der Lagerbestände für kritische Materialien als Puffer im Falle einer Unterbrechungen der Lieferkette.",
          measure3: "Verbesserte Wetterüberwachung: Nutzung von Wettervorhersagetechnologien, um potenzielle Unterbrechungen vorherzusagen und abzumildern."
        }
      },
      {
        title: "Beispiel 2: Überflutungsgefährdung von Produktionsstätten",
        impactTitle: "Auswirkungen:",
        impactText: "Überschwemmungen durch Starkniederschläge können Produktionslinien beschädigen und die Herstellung von Komponenten für erneuerbare Energien stören.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Hochwasserresistente Infrastruktur: Produktionsanlagen erhöhen und Hochwasserschutzmauern um überflutungsgefährdete Anlagen errichten.",
          measure2: "Abdichtungssysteme: Verwenden Sie wasserdichte Materialien und Dichtungen, um Maschinen und Infrastruktur vor möglichen Wasserschäden zu schützen."
        }
      }
    ],
    constructionTitle: "Wie können KMU im Baugewerbe Klimarisiken begegnen?",
    constructionExamples: [
      {
        title: "Beispiel 1: Hitzewellen und Arbeitersicherheit auf Baustellen",
        impactTitle: "Auswirkungen:",
        impactText: "Extreme Hitze auf Baustellen kann zu Hitzestress bei den Arbeitern führen, die Produktivität verringern und das Unfallrisiko erhöhen.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Anpassung der Arbeitszeiten: Verlegen der Bauzeiten auf die frühen Morgenstunden oder den späten Nachmittag, um Hitzeperioden zu vermeiden",
          measure2: "Abkühlstationen: Einrichten von schattigen Ruhezonen und Kühlstationen mit Wasser und Ventilatoren, damit sich Arbeitskräfte in den Pausen abkühlen können.",
          measure3: "Hitzeresistente Ausrüstung: Verwendung von Baumaschinen, die auch bei hohen Temperaturen effizient arbeiten können, um Überhitzung oder Ausfälle zu vermeiden."
        }
      },
      {
        title: "Beispiel 2: Starkniederschläge und Überschwemmungen verzögern Bauzeiten",
        impactTitle: "Auswirkungen:",
        impactText: "Starke Regenfälle während der Bauphase können Baustellen überfluten, Material beschädigen und die Projektlaufzeit verzögern.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Temporäre Entwässerungssysteme: Installation temporärer Entwässerungslösungen wie Gräben oder Pumpen, um überschüssiges Wasser von der Baustelle wegzuleiten.",
          measure2: "Wasserfeste Lagerung von Materialien: Lagerung der Materialien in wasserfesten Behältern oder auf erhöhten Lagerflächen, um sie vor Regenschäden zu schützen.",
          measure3: "Witterungsbeständige Baustellenplanung: Das Gelände so gestalten, dass Wasseransammlungen und Überschwemmungen bei Regen vermieden werden. "
        }
      },
      {
        title: "Beispiel 3: Stürme und Starkwinde mit Auswirkungen auf Baumaschinen und Bauwerke",
        impactTitle: "Auswirkungen:",
        impactText: "Starker Wind während der Bauarbeiten kann Gerüste, Kräne und unfertige Bauten beschädigen, was ein Sicherheitsrisiko für die Arbeitskräfte darstellt und den Baufortschritt verlangsamt.",
        adaptationMeasuresTitle: "Anpassungsmaßnahmen:",
        adaptationMeasures: {
          measure1: "Windbeständige Gerüste: Verwendung stabiler Gerüste und Sicherung der Kräne mit windbeständigen Befestigungen, um zu verhindern, dass die Ausrüstung bei Sturm umkippt",
          measure2: "Sicherung der Baustelle vor Stürmen: Entwicklung von Verfahren zur schnellen Sicherung oder Demontage von temporären Strukturen und Ausrüstungen bei vorhergesagtem starkem Wind.",
          measure3: " Echtzeit-Wetterüberwachung: Implementierung von Echtzeit-Wetterüberwachungssystemen, um die Arbeitskräfte im Voraus zu warnen und ihnen die Möglichkeit zu geben, ihre Ausrüstung zu sichern und gegebenenfalls zu evakuieren."
        }
      }
    ]
  },
  italian: {
    energyTitle: "Come possono le PMI nel settore energetico affrontare i rischi climatici?",
    energyExamples: [
      {
        title: "Esempio 1: Ondate di calore e stress termico sui sistemi di energia solare",
        impactTitle: "Impatto:",
        impactText: "Ondate di calore prolungate possono causare il surriscaldamento dei pannelli solari, riducendone l’efficienza e la durata. Le alte temperature possono anche aumentare il rischio di incendi nelle aree circostanti l’installazione.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Sistemi di raffreddamento: Implementare sistemi di raffreddamento attivi per mantenere i pannelli solari a temperature operative ottimali",
          measure2: "Selezione dei materiali: Utilizzare materiali resistenti al calore per pannelli e supporti, riducendo l’impatto delle temperature estreme.",
          measure3: "Gestione della vegetazione: Rimuovere regolarmente la vegetazione attorno all’installazione per ridurre il rischio di incendi e migliorare la circolazione dell’aria.",
          measure4: "Sistemi di monitoraggio: Installare sensori di temperatura e sistemi di monitoraggio per rilevare lo stress termico e adottare misure tempestive."
        }
      },
      {
        title: "Esempio 2: Cambiamenti nei modelli di vento e tempeste che colpiscono le turbine eoliche",
        impactTitle: "Impatto:",
        impactText: "Tempeste più forti e frequenti possono aumentare l’usura delle turbine eoliche, causando guasti meccanici. I cambiamenti nei modelli di vento possono inoltre influenzare i livelli di produzione energetica.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Rinforzi strutturali: Rafforzare le torri e le pale delle turbine per resistere a venti più forti e condizioni di tempesta.",
          measure2: "Monitoraggio del vento: Utilizzare sistemi meteorologici avanzati per prevedere i modelli di vento e regolare il funzionamento delle turbine di conseguenza.",
          measure3: "Piani di manutenzione: Aumentare la frequenza dei controlli di manutenzione, soprattutto dopo le tempeste, per individuare e riparare tempestivamente eventuali danni.",
          measure4: "Assicurazione: Garantire una copertura assicurativa completa per i danni da tempesta, riducendo il rischio finanziario."
        }
      },
      {
        title: "Esempio 3: Precipitazioni intense che colpiscono le centrali idroelettriche",
        impactTitle: "Impatto:",
        impactText: "Piogge intense e inondazioni possono danneggiare le infrastrutture, causare accumuli di sedimenti e provocare interruzioni operative nelle centrali idroelettriche.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Barriere anti-inondazione: Installare barriere attorno alle infrastrutture chiave per proteggerle dall’innalzamento del livello dell’acqua.",
          measure2: "Gestione dei sedimenti: Implementare sistemi di gestione dei sedimenti, come trappole per il limo, per prevenire ostruzioni nelle turbine e negli altri componenti.",
          measure3: "Progettazione delle infrastrutture: Costruire canali di sfogo e sistemi di troppo pieno per gestire volumi d’acqua elevati senza danneggiare l’impianto.",
          measure4: "Piani di emergenza: Sviluppare e aggiornare regolarmente piani di risposta alle emergenze per eventi meteorologici estremi, garantendo un’azione rapida ed efficace in caso di precipitazioni intense."
        }
      }
    ],
    manufacturingTitle: "Come possono le PMI nel settore manifatturiero affrontare i rischi climatici?",
    manufacturingExamples: [
      {
        title: "Come possono le PMI nel settore manifatturiero affrontare i rischi climatici?",
        impactTitle: "Impatto:",
        impactText: "Gli eventi meteorologici estremi possono interrompere la catena di approvvigionamento dei materiali chiave, compromettendo la produzione tempestiva di tecnologie per l’energia rinnovabile.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Diversificazione della catena di approvvigionamento: Procurarsi materiali da più fornitori situati in diverse regioni per ridurre la dipendenza da un’unica area soggetta a rischi climatici.",
          measure2: "Gestione dell’inventario: Aumentare le scorte di materiali critici per mitigare le interruzioni nella catena di approvvigionamento.",
          measure3: "Monitoraggio meteorologico avanzato: Utilizzare tecnologie di previsione meteorologica per anticipare e ridurre potenziali disagi."
        }
      },
      {
        title: "Esempio 2: Rischi di alluvione negli impianti di produzione",
        impactTitle: "Impatto:",
        impactText: "Le inondazioni dovute a precipitazioni intense possono danneggiare le linee di produzione e interrompere la fabbricazione di componenti per l’energia rinnovabile",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Infrastrutture resilienti alle alluvioni: Elevare le attrezzature di produzione e installare barriere anti-alluvione negli impianti a rischio.",
          measure2: "Sistemi di impermeabilizzazione: Utilizzare materiali impermeabili e sigillanti per proteggere i macchinari e le infrastrutture dai danni causati dall’acqua."
        }
      }
    ],
    constructionTitle: "Come possono le PMI nel settore delle costruzioni affrontare i rischi climatici?",
    constructionExamples: [
      {
        title: "Esempio 1: Ondate di calore e sicurezza dei lavoratori nei cantieri",
        impactTitle: "Impatto:",
        impactText: "Il caldo estremo durante le attività di costruzione può causare stress termico nei lavoratori, ridurre la produttività e aumentare il rischio di incidenti.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Regolazione degli orari di lavoro: Spostare l’orario di lavoro alle prime ore del mattino o nel tardo pomeriggio per evitare i periodi di massimo calore.",
          measure2: "Stazioni di raffreddamento: Allestire aree ombreggiate e punti di ristoro con acqua e ventilatori per permettere ai lavoratori di rinfrescarsi durante le pause",
          measure3: "Attrezzature resistenti al calore: Utilizzare macchinari da costruzione progettati per funzionare efficientemente ad alte temperature, evitando surriscaldamenti o guasti."
        }
      },
      {
        title: "Esempio 2: Aumento delle precipitazioni e inondazioni che ritardano i tempi di costruzione",
        impactTitle: "Impatto:",
        impactText: "Le piogge intense durante la costruzione possono allagare i cantieri, danneggiare i materiali e ritardare i tempi di completamento dei progetti.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Sistemi di drenaggio temporanei: Installare soluzioni di drenaggio provvisorie, come trincee o pompe, per deviare l’acqua in eccesso lontano dal cantiere.",
          measure2: "Stoccaggio impermeabile dei materiali: Conservare i materiali in contenitori impermeabili o in aree rialzate per proteggerli dai danni causati dalla pioggia.",
          measure3: "Pianificazione resiliente del sito: Modificare la pendenza e la disposizione del cantiere per ridurre il ristagno d’acqua e il rischio di allagamenti durante i temporali."
        }
      },
      {
        title: "Esempio 3: Tempeste e forti venti che colpiscono attrezzature e strutture in costruzione",
        impactTitle: "Impatto:",
        impactText: "I venti forti durante la costruzione possono danneggiare impalcature, gru e strutture incomplete, mettendo a rischio la sicurezza dei lavoratori e rallentando i lavori.",
        adaptationMeasuresTitle: "Misure di adattamento:",
        adaptationMeasures: {
          measure1: "Impalcature resistenti al vento: Utilizzare impalcature rinforzate e fissare le gru con ancoraggi resistenti al vento per prevenire il ribaltamento delle attrezzature durante le tempeste.",
          measure2: "Messa in sicurezza preventiva del cantiere: Sviluppare procedure per fissare o smontare rapidamente le strutture temporanee e le attrezzature in caso di previsioni di vento forte.",
          measure3: "•  Monitoraggio meteorologico in tempo reale: Implementare sistemi di monitoraggio meteorologico per fornire avvisi tempestivi ai lavoratori, permettendo loro di mettere in sicurezza le attrezzature ed evacuare se necessario."
        }
      }
    ]
  }
  ,
  czech: {
    energyTitle: "Jak mohou malé a střední podniky v energetickém sektoru čelit klimatickým rizikům?",
    energyExamples: [
      {
        title: "Příklad 1: Vlny veder a tepelný stres na systémech solární energie",
        impactTitle: "Dopad:",
        impactText: "Prodloužené vlny veder mohou způsobit přehřátí solárních panelů, což vede k jejich nižší účinnosti a zkrácení životnosti. Vysoké teploty také zvyšují riziko požárů v okolí instalace.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Chladicí systémy: Implementace aktivních chladicích systémů pro udržení solárních panelů na optimální provozní teplotě.",
          measure2: "Výběr materiálů: Používání teplotně odolných materiálů pro panely a podpěry, čímž se sníží dopad extrémních teplot.",
          measure3: "Správa vegetace: Pravidelné odstraňování vegetace kolem instalace za účelem snížení rizika požárů a zlepšení cirkulace vzduchu.",
          measure4: "Monitorovací systémy: Instalace teplotních senzorů a monitorovacích systémů pro detekci tepelného stresu a včasné přijetí opatření."
        }
      },
      {
        title: "Příklad 2: Změny větrných vzorců a bouře ovlivňující větrné turbíny",
        impactTitle: "Dopad:",
        impactText: "Silnější a častější bouře mohou zvýšit opotřebení větrných turbín, což může vést k mechanickým poruchám. Změny větrných vzorců také mohou ovlivnit úroveň produkce energie.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Strukturální posílení: Posílení věží a lopatek turbín pro odolnost vůči silnějším větrům a bouřkovým podmínkám.",
          measure2: "Monitorování větru: Použití pokročilých meteorologických systémů pro predikci větrných vzorců a odpovídající úpravu provozu turbín.",
          measure3: "Údržbové plány: Zvýšení frekvence kontrol údržby, zejména po bouřích, pro včasnou detekci a opravu poškození.",
          measure4: "Pojištění: Zajištění plného pojištění proti škodám způsobeným bouřemi, což snižuje finanční riziko."
        }
      },
      {
        title: "Příklad 3: Intenzivní srážky ovlivňující vodní elektrárny",
        impactTitle: "Dopad:",
        impactText: "Intenzivní deště a povodně mohou poškodit infrastrukturu, způsobit usazeniny a vést k výpadkům provozu ve vodních elektrárnách.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Protipovodňové bariéry: Instalace bariér kolem klíčových infrastruktury pro jejich ochranu před zvyšováním hladiny vody.",
          measure2: "Správa usazenin: Implementace systémů pro správu usazenin, jako jsou nádrže na bahno, pro prevenci ucpávání turbín a dalších komponentů.",
          measure3: "Návrh infrastruktury: Stavba odtokových kanálů a přepadových systémů pro řízení vysokých objemů vody bez poškození zařízení.",
          measure4: "Nouzové plány: Vývoj a pravidelná aktualizace nouzových plánů pro extrémní povětrnostní události, které zajistí rychlou a účinnou reakci při intenzivních srážkách."
        }
      }
    ],
    manufacturingTitle: "Jak mohou malé a střední podniky v průmyslové výrobě čelit klimatickým rizikům?",
    manufacturingExamples: [
      {
        title: "Jak mohou malé a střední podniky v průmyslové výrobě čelit klimatickým rizikům?",
        impactTitle: "Dopad:",
        impactText: "Extrémní povětrnostní události mohou narušit dodavatelské řetězce klíčových materiálů, což ohrožuje včasnou výrobu technologií pro obnovitelné zdroje energie.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Diversifikace dodavatelského řetězce: Zajištění materiálů od více dodavatelů ve různých regionech, aby se snížila závislost na jediné oblasti zasažené klimatickými riziky.",
          measure2: "Správa zásob: Zvýšení zásob kritických materiálů pro zmírnění přerušení dodavatelského řetězce.",
          measure3: "Pokročilé meteorologické monitorování: Použití meteorologických predikčních technologií pro předvídání a zmírnění potenciálních problémů."
        }
      },
      {
        title: "Příklad 2: Riziko povodní v průmyslových závodech",
        impactTitle: "Dopad:",
        impactText: "Povodně způsobené intenzivními srážkami mohou poškodit výrobní linky a přerušit výrobu komponent pro obnovitelné zdroje energie.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Infrastruktura odolná proti povodním: Zvýšení výrobního vybavení a instalace protipovodňových bariér v ohrožených závodech.",
          measure2: "Izolační systémy: Použití vodotěsných materiálů a těsnění pro ochranu strojů a infrastruktury před poškozením vodou."
        }
      }
    ],
    constructionTitle: "Jak mohou malé a střední podniky v sektoru stavebnictví čelit klimatickým rizikům?",
    constructionExamples: [
      {
        title: "Příklad 1: Vlny veder a bezpečnost pracovníků na stavbách",
        impactTitle: "Dopad:",
        impactText: "Extrémní teplo při stavebních pracích může způsobit teplotní stres pracovníků, snížit produktivitu a zvýšit riziko nehod.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Úprava pracovního času: Posunutí pracovních hodin na ranní nebo večerní hodiny, aby se předešlo obdobím nejvyššího tepla.",
          measure2: "Chladící stanice: Zřízení zastíněných prostor a míst s vodou a ventilátory, kde si pracovníci mohou během přestávek odpočinout.",
          measure3: "Teplotně odolné vybavení: Použití stavebních strojů navržených pro efektivní fungování při vysokých teplotách, aby se předešlo přehřátí nebo poruchám."
        }
      },
      {
        title: "Příklad 2: Zvýšené srážky a povodně, které zpožďují stavební termíny",
        impactTitle: "Dopad:",
        impactText: "Intenzivní deště během výstavby mohou zaplavit staveniště, poškodit materiály a zpozdit dokončení projektů.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Dočasné drenážní systémy: Instalace provizorních drenážních řešení, jako jsou příkopy nebo čerpadla, pro odvedení přebytečné vody z místa stavby.",
          measure2: "Vodotěsné skladování materiálů: Ukládání materiálů do vodotěsných nádob nebo na zvýšené plochy, aby byly chráněny před poškozením deštěm.",
          measure3: "Resilientní plánování staveniště: Úprava sklonu a rozložení staveniště pro snížení rizika stagnace vody a zaplavení během bouřek."
        }
      },
      {
        title: "Příklad 3: Bouře a silné větry, které poškozují vybavení a konstrukce na staveništi",
        impactTitle: "Dopad:",
        impactText: "Silné větry během výstavby mohou poškodit lešení, jeřáby a nedokončené konstrukce, což ohrožuje bezpečnost pracovníků a zpomaluje práce.",
        adaptationMeasuresTitle: "Opatření pro přizpůsobení:",
        adaptationMeasures: {
          measure1: "Vě tru odolné lešení: Použití zesíleného lešení a upevnění jeřábů s větrnými kotvami, aby se předešlo převrácení zařízení během bouří.",
          measure2: "Prevence na staveništi: Vypracování postupů pro rychlou fixaci nebo demontáž dočasných konstrukcí a zařízení v případě předpovědi silného větru.",
          measure3: "Real-time meteorologické monitorování: Implementace meteorologických monitorovacích systémů pro včasné varování pracovníků, aby mohli zařízení zajistit a evakuovat se v případě potřeby."
        }
      }
    ]
  }
};

function Adaptation({ category }) {
    // Select the appropriate examples and title based on the category prop
    const [currentLanguage, setCurrentLanguage] = useState(
      localStorage.getItem("language") || "english"
    );
    const categoryExamples = translations[currentLanguage][`${category}Examples`];
    const title = translations[currentLanguage][`${category}Title`] || "How can SMEs address climate risks?";
    

    return (
        <div className="text-start adaptation">
            <h2>{title}</h2>
            {categoryExamples && categoryExamples.map((example, index) => (
                <div key={index}>
                    <h3>{example.title}</h3>
                    <ul>
                        <li>
                            <strong>{example.impactTitle}</strong> {example.impactText}
                        </li>
                        <li>
                            <strong>{example.adaptationMeasuresTitle}</strong>
                            <ul>
                                {Object.values(example.adaptationMeasures).map((measure, i) => (
                                    <li key={i}><strong>{measure.split(":")[0]}:</strong> {measure.split(":")[1]}</li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                </div>
            ))}
        </div>
    );
}

export default Adaptation;
